import { Component, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { AccountService } from '../../../services';
import { AppUtils } from '../../../helpers';

@Component({
    selector: 'AccountCreated',
    templateUrl: './account.created.component.html'
})

export class AccountCreatedComponent {
    @BlockUI('container-block-ui') blockUI: NgBlockUI;

    private userId: string;

    constructor(private route: ActivatedRoute,
        protected vcr: ViewContainerRef,
        private toastr: ToastsManager,
        private appUtils: AppUtils,
        private accountService: AccountService) {

        this.toastr.setRootViewContainerRef(vcr);

        this.route.params.subscribe(params => {
            this.userId = params['id'];
        });
    }

    resendActivationLink() {
        this.blockUI.start();
        this.accountService.sendVerificationEmail(this.userId)
            .subscribe(
                (data: any) => {
                    console.log(data);
                    this.blockUI.stop();
                    this.toastr.success('Account confirmation email has been sent successfully.');
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }
}




// WEBPACK FOOTER //
// ./src/components/account/created/account.created.component.ts